import React from 'react';
import { Modal } from '@common/Modal';
import { Button } from '@common/Button';
import { Copy } from 'lucide-react';
import { logInfo } from '@utils/logger';

export const StructureIdsModal = ({ isOpen, onClose, structures = [] }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    logInfo('Structure references copied to clipboard');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Structure References">
      <div className="p-6 space-y-4">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-white font-medium">Structure References ({structures.length})</h3>
          <Button
            onClick={() => copyToClipboard(structures.map(s => s.reference || s.id).join('\n'))}
            className="p-2 bg-gray-700 hover:bg-gray-600 text-white rounded"
            title="Copy all references"
          >
            <Copy className="w-4 h-4" />
          </Button>
        </div>

        <div className="bg-gray-200/50 rounded-lg max-h-96 overflow-y-auto">
          {structures.length > 0 ? (
            <ul className="divide-y divide-gray-700">
              {structures.map((structure, index) => (
                <li key={index} className="p-2 hover:bg-gray-700/50">
                  {structure.reference || structure.id || `Structure ${index + 1}`}
                </li>
              ))}
            </ul>
          ) : (
            <div className="p-4 text-center text-gray-400">
              No structures found
            </div>
          )}
        </div>

        <div className="flex justify-end">
          <Button
            onClick={onClose}
            className="bg-gray-700 hover:bg-gray-600 text-white"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default StructureIdsModal;